import React, {Component} from 'react'
import {browserHistory, Link, Redirect, Route, Router} from 'react-router'
import StartPage from './pages/index'
import AboutPage from './pages/about'
import ProductionPage from './pages/production'
import PartnersPage from './pages/partners'
import BuyPage from './pages/buy'
import Selection from './pages/selection'
import Code from './pages/searchByCode'
import AutoPart from './pages/autoPart'
import {loadItemType} from "./itemtype"

import shocks from './pages/production/shocks'
import air_filter from './pages/production/air_filter'
import cabin_filter from './pages/production/cabin_filter'
import fuel_filter from './pages/production/fuel_filter'
import oil_filter from './pages/production/oil_filter'
import high_tension_leads from './pages/production/high-tension-leads'
import gas_spring from './pages/production/gas-spring'
import clutch from './pages/production/clutch'
import clutch_disc from './pages/production/clutch-disc'
import universal_joint from './pages/production/universal-joint'
import water_pump from './pages/production/water-pump'
import bearing from './pages/production/bearing'
import timing_belt from './pages/production/timing-belt'
import belt_tensioner from './pages/production/belt-tensioner'
import belts_v from './pages/production/belts-v'
import belts_ribbed from './pages/production/belts-ribbed'
import ball_joint from './pages/production/ball-joint'
import tie_rod_ends from './pages/production/tie-rod-ends'
import silent_block from './pages/production/silent-block';
import stabilizer_link from "./pages/production/stabilizer-link";
import ignition_coil from './pages/production/ignition-coil'
import spark_plug_iridium from './pages/production/spark-plug-iridium'
import spark_plug_nicu from './pages/production/spark-plug-nicu'
import thermostat from './pages/production/thermostat'
import brake_pads from './pages/production/brake-pads'
import cv_joint from './pages/production/cv-joint'
import wipes_blade_fb from './pages/production/wipers-blade-fb'
import wipes_blade_hw from './pages/production/wipers-blade-hw'
import wipes_blade_rx from './pages/production/wipers-blade-rx'
import Loader from "./basic/LoaderCircle";
import BasePage from './BasePage'
import Policy from './pages/policy'
import GoogleAnalytics from './Analytics'
import News from './pages/news'
import New from './pages/new'

import IsAdminContext from './context/isAdminContext';
import CurrentLanguageContext from './context/currentLanguageContext';
import getIsAdmin from 'src/text/isAdmin';
import getCurrentLanguage from 'src/text/currentLanguage';


class App extends Component {
  state = {
    rendered: false,
    isAdmin: false,
    currentLanguage: '',
  }

  componentDidMount() {
    Promise.all([
      getIsAdmin(),
      getCurrentLanguage(),
      loadItemType(),
    ]).then(([isAdmin, currentLanguage]) => this.setState({ rendered: true, isAdmin, currentLanguage }));
  }

  render() {
    return (
      !this.state.rendered ?
      <Loader/>
      :
      <IsAdminContext.Provider value={this.state.isAdmin}>
        <CurrentLanguageContext.Provider value={this.state.currentLanguage}>
          <Router onUpdate={() => window.scrollTo(0, 0)} history={browserHistory}>
            <Route component={BasePage}>
              <Redirect from="/news/" to="/news" state={{status: 301}}/>
              <Redirect from="/new/:id/" to="/new/:id" state={{status: 301}}/>
              <Redirect from="/selection/" to="/selection" state={{status: 301}}/>
              <Redirect from="/article/:article/" to="/article/:article" state={{status: 301}}/>
              <Redirect from="/item/:id/" to="/item/:id" state={{status: 301}}/>
              <Redirect from="/internet-stores/" to="/internet-stores" state={{status: 301}}/>
              <Redirect from="/retail-stores/" to="/retail-stores" state={{status: 301}}/>
              <Redirect from="/production/" to="/production" state={{status: 301}}/>
              <Redirect from="/partners/" to="/partners" state={{status: 301}}/>
              <Redirect from="/about/" to="/about" state={{status: 301}}/>
              <Redirect from="/main/" to="/" state={{status: 301}}/>
              <Redirect from="/main" to="/" state={{status: 301}}/>
              <Redirect from="/policy/" to="/policy" state={{status: 301}}/>
              <Redirect from="/shocks/" to="/shocks" state={{status: 301}}/>
              <Redirect from="/air-filters/" to="/air-filters" state={{status: 301}}/>
              <Redirect from="/cabin-filters/" to="/cabin-filters" state={{status: 301}}/>
              <Redirect from="/fuel-filters/" to="/fuel-filters" state={{status: 301}}/>
              <Redirect from="/oil-filters/" to="/oil-filters" state={{status: 301}}/>
              <Redirect from="/high-tension-leads/" to="/high-tension-leads" state={{status: 301}}/>
              <Redirect from="/gas-spring/" to="/gas-spring" state={{status: 301}}/>
              <Redirect from="/clutch/" to="/clutch" state={{status: 301}}/>
              <Redirect from="/clutch-disc/" to="/clutch-disc" state={{status: 301}}/>
              <Redirect from="/universal-joint/" to="/universal-joint" state={{status: 301}}/>
              <Redirect from="/water-pump/" to="/water-pump" state={{status: 301}}/>
              <Redirect from="/bearing/" to="/bearing" state={{status: 301}}/>
              <Redirect from="/timing-belt/" to="/timing-belt" state={{status: 301}}/>
              <Redirect from="/belt-tensioner/" to="/belt-tensioner" state={{status: 301}}/>
              <Redirect from="/belts-v/" to="/belts-v" state={{status: 301}}/>
              <Redirect from="/belts-ribbed/" to="/belts-ribbed" state={{status: 301}}/>
              <Redirect from="/suspension-parts/" to="/suspension-parts" state={{status: 301}}/>
              <Redirect from="/ball-joint/" to="/ball-joint" state={{status: 301}}/>
              <Redirect from="/tie-rod-ends/" to="/tie-rod-ends" state={{status: 301}}/>
              <Redirect from="/silent-block/" to="/silent-block" state={{status: 301}}/>
              <Redirect from="/stabilizer-link/" to="/stabilizer-link" state={{status: 301}}/>
              <Redirect from="/ignition-coil/" to="/ignition-coil" state={{status: 301}}/>
              <Redirect from="/spark-plugs-iridium/" to="/spark-plugs-iridium" state={{status: 301}}/>
              <Redirect from="/spark-plugs-nicu/" to="/spark-plugs-nicu" state={{status: 301}}/>
              <Redirect from="/thermostat/" to="/thermostat" state={{status: 301}}/>
              <Redirect from="/brake-pads/" to="/brake-pads" state={{status: 301}}/>
              <Redirect from="/cv-joint/" to="/cv-joint" state={{status: 301}}/>
              <Redirect from="/wipers-blade-fb/" to="/wipers-blade-fb" state={{status: 301}}/>
              // <Redirect from="/wipers-blade-hw/" to="/wipers-blade-hw" state={{status: 301}}/>
              <Redirect from="/wipers-blade-rx/" to="/wipers-blade-rx" state={{status: 301}}/>
              <Route path="/" component={StartPage}/>
              <Route path="/news" component={News}/>
              <Route path="/new/:id" component={New}/>
              <Route path="/selection" component={Selection}/>
              <Route path="/article/:article" component={Code}/>
              <Route path="/item/:id" component={AutoPart}/>
              <Route path="/internet-stores" component={() => <BuyPage type="internet"/>}/>
              <Route path="/retail-stores" component={() => <BuyPage type="retail"/>}/>
              <Route path="/production" component={ProductionPage}/>
              <Route path="/partners" component={PartnersPage}/>
              <Route path="/about" component={AboutPage}/>
              <Route path="/policy" component={Policy}/>
              <Route path="/shocks" component={shocks}/>
              <Route path="/air-filter" component={air_filter}/>
              <Route path="/cabin-filter" component={cabin_filter}/>
              <Route path="/fuel-filter" component={fuel_filter}/>
              <Route path="/oil-filter" component={oil_filter}/>
              <Route path="/high-tension-leads" component={high_tension_leads}/>
              <Route path="/gas-spring" component={gas_spring}/>
              <Route path="/clutch" component={clutch}/>
              <Route path="/clutch-disc" component={clutch_disc}/>
              <Route path="/universal-joint" component={universal_joint}/>
              <Route path="/water-pump" component={water_pump}/>
              <Route path="/bearing" component={bearing}/>
              <Route path="/timing-belt" component={timing_belt}/>
              <Route path="/belt-tensioner" component={belt_tensioner}/>
              <Route path="/belts-v" component={belts_v}/>
              <Route path="/belts-ribbed" component={belts_ribbed}/>
              <Route path="/ball-joint" component={ball_joint}/>
              <Route path="/tie-rod-ends" component={tie_rod_ends}/>
              <Route path="/silent-block" component={silent_block}/>
              <Route path="/stabilizer-link" component={stabilizer_link}/>
              <Route path="/ignition-coil" component={ignition_coil}/>
              <Route path="/spark-plugs-iridium" component={spark_plug_iridium}/>
              <Route path="/spark-plugs-nicu" component={spark_plug_nicu}/>
              <Route path="/thermostat" component={thermostat}/>
              <Route path="/brake-pads" component={brake_pads}/>
              <Route path="/cv-joint" component={cv_joint}/>
              <Route path="/wipers-blade-fb" component={wipes_blade_fb}/>
              // <Route path="/wipers-blade-hw" component={wipes_blade_hw}/>
              <Route path="/wipers-blade-rx" component={wipes_blade_rx}/>
            </Route>

            <Route path="*" component={GoogleAnalytics(NoMatch)}/>
          </Router>
        </CurrentLanguageContext.Provider>
      </IsAdminContext.Provider>
    );
  }
}

function NoMatch() {
  return (
    <div>
      Страницы по заданному адресу не существует.
      <Link to="/">
        Перейти на стартовую страницу...
      </Link>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js